"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STEPS_ORDER = exports.GiftingFlowStep = void 0;
var GiftingFlowStep;
exports.GiftingFlowStep = GiftingFlowStep;

(function (GiftingFlowStep) {
  GiftingFlowStep["Contacts"] = "contacts";
  GiftingFlowStep["Gift"] = "gift";
  GiftingFlowStep["Messaging"] = "messaging";
  GiftingFlowStep["Send"] = "send";
})(GiftingFlowStep || (exports.GiftingFlowStep = GiftingFlowStep = {}));

var STEPS_ORDER = [GiftingFlowStep.Contacts, GiftingFlowStep.Gift, GiftingFlowStep.Messaging, GiftingFlowStep.Send];
exports.STEPS_ORDER = STEPS_ORDER;